import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  InputAdornment,
  Tooltip,
  IconButton,
} from "@mui/material";
import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";

import { CloudUpload, CalendarToday } from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../utilities/ApiConfig";
import formatDate from "../utilities/formatDate";
import addregularizeicon from "../assets/images/addregularizeicon.png";
import editmodificationimg from "../assets/images/editmodificationimg.png";
import { faO } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const RegularizeTable = ({ data }) => {
  debugger;
  const [openPopup, setOpenPopup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [districts, setDistricts] = useState([]);
  const [sros, setSros] = useState([]);
  const [staff, setStaff] = useState([]);
  const [staffSro, setStaffSro] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [roles, setRoles] = useState([]);
  const { userDetails } = useSelector((state) => state.auth);
  const [regularizeFormShow, setRegularizeFormShow] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [fromDate, setFromDate] = useState();
  console.log("user login data", userDetails);
  console.log("districts", districts);
  const [formData, setFormData] = useState({
    district: "",
    subRegistrar: "",
    fromDate: "",
    toDate: "",
    behalfOf: "",
    assignedRole: "",
    assigneeName: "",
    uploadLetter: null,
  });
  console.log("formData", formData);
  const fetchMasterData = async () => {
    try {
      const [districtRes, designationRes, roleRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/Master/get_District_Mas`),
        axios.get(`${API_BASE_URL}/Master/get_Designation_Mas`),
        axios.get(`${API_BASE_URL}/Master/get_Role_Mas`),
      ]);

      setDistricts(districtRes.data.data);
      setDesignations(designationRes.data.data);
      setRoles(roleRes.data.data);
    } catch (error) {
      console.error("Error fetching master data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSroData = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/Master/get_sro_master_data?dcode=${userDetails.dcode}`
      );
      setSros(response.data.data);
    } catch (error) {
      console.error("Error fetching SRO data:", error);
    }
  };
  const fetchStaffData = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/Master/sp_get_dis_staff?dcode=${userDetails.dcode}`
      );
      setStaff(response.data.data);
    } catch (error) {
      console.error("Error fetching SRO data:", error);
    }
  };
  const fetchStaffSroData = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/Master/sp_get_sro_staff?dcode=${userDetails.dcode}&srocode=${userDetails.srocode}`
      );
      setStaffSro(response.data.data);
    } catch (error) {
      console.error("Error fetching SRO data:", error);
    }
  };

  useEffect(() => {
    fetchMasterData();
    fetchStaffData();
    fetchStaffSroData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

    // If district is changed, fetch corresponding SROs
    if (name === "dcode") {
      fetchSroData(value);
      setFormData((prevData) => ({ ...prevData, srocode: "" })); // Reset SRO selection
    }
  };

  const handleFileUpload = (e) => {
    setFormData((prev) => ({ ...prev, uploadLetter: e.target.files[0] }));
  };
  const handleNavigate = () => {
    setRegularizeFormShow(true);
  };
  const handleClose = () => {
    setRegularizeFormShow(false);
  };
  console.log(data);

  const navigate = useNavigate();

  const handleNavigateUpdatePages = (typeRecpt, regYear, vol, sr) => {
    debugger;
    let targetPage = "";

    if (typeRecpt.toLowerCase() === "search") {
      targetPage = "/SearchReceipt";
    } else if (typeRecpt.toLowerCase() === "copy") {
      targetPage = "/CopyReceipt";
    } else if (typeRecpt.toLowerCase() === "inspection") {
      targetPage = "/InspectionReceipt";
    } else if (typeRecpt.toLowerCase() === "commission") {
      targetPage = "/Commision";
    } else if (typeRecpt.toLowerCase() === "defeceit") {
      targetPage = "/DeficiateReceipt";
    } else if (typeRecpt.toLowerCase() === "others") {
      targetPage = "/Other";
    } else if (typeRecpt.toLowerCase() === "miscelleneous") {
      targetPage = "/NewReceipt";
    } else {
      toast.error("Invalid receipt type");
      return;
    }

    navigate(targetPage, {
      state: { regYear, vol, sr, typeRecpt, mod: true },
    });
  };

  const handleGetVoucherData = async () => {
    // try {
    //   const url = `${API_BASE_URL}/Accounts/get_voucher_details_by_voucher_id/${voucherId}`;
    //   const response = await axios.get(url);
    //   console.log('get data from the table', response.data);
    //   //   setVoucherData(response.data);
    //   //   setShowVoucher(true);
    // } catch (err) {
    //   toast.error("Failed to Load Expense Voucher.");
    // }
  };
  debugger;
  console.log(data);
  const TableData = Array.isArray(data)
    ? data.map((item, index) => ({
        ...item,
        sn: index + 1,
        dateRange: `${item.startDate} - ${item.endDate}`,
      }))
    : [];

  console.log(TableData);

  const columns = [
    {
      name: "username",
      label: "Name of Asignee",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-center text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "dateRange",
      label: "From date - To date",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "dcode",
      label: "Asigned District",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "srocode",
      label: "Asigned SRO",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">
            {formatDate(value, "dd/MM/yyyy")}
          </div>
        ),
      },
    },
    {
      name: "userRole",
      label: "Asigned Role",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "attachment",
      label: "Document",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "approvedBy",
      label: "Approval By",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "userId",
      label: "ACTION",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const rowData = data[tableMeta.rowIndex]; // Get row data
          return (
            <button
              className="capitalize py-1 px-2 rounded-md cursor-pointer"
              onClick={() =>
                handleNavigateUpdatePages(
                  rowData.typeRecpt,
                  rowData.regYear,
                  rowData.vol,
                  rowData.sr
                )
              }
            >
              <img
                src={editmodificationimg}
                alt="Edit Modification"
                className="w-6 h-6"
              />
            </button>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    elevation: 0,
    rowsPerPageOptions: [10, 15, 25, 50],
    responsive: "standard",
    tableBodyHeight: "auto",
    tableBodyMaxHeight: "auto",
    download: false, // Disables the default download (CSV export) button
    print: false, // Disables the default print button
    viewColumns: false, // Disables the default view columns button
    search: true,
    filter: false,
    customToolbar: () => {
      return (
        <>
          {userDetails?.userRole !== "SuperAdmin" && (
            <Tooltip title="Add New">
              <>
                <button
                  onClick={handleNavigate}
                  className="bg-blue-400 text-white text-sm px-3 py-2 rounded hover:bg-blue-700 focus:outline-none inline-flex items-center gap-2"
                >
                  <img
                    src={addregularizeicon}
                    alt="Thumb Image"
                    className="h-5 w-5"
                  />
                  New Request
                </button>
              </>
            </Tooltip>
          )}
        </>
      );
    },
  };

  const getMuiTheme = () =>
    createTheme({
      typography: {
        fontFamily: "Poppins",
      },
      palette: {
        background: {
          paper: "#ffffff",
          default: "#ffffff",
        },
        mode: "light",
      },
      components: {
        MuiTableCell: {
          styleOverrides: {
            head: {
              backgroundColor: "#ffffff !important",
              color: "#929292 !important",
              padding: "2px 1px",
              borderBottom: "2px solid #ECECEC",
              borderRight: "0px solid #ddd",
              fontSize: "10px",
              textAlign: "start",
              "@media (min-width: 768px)": {
                // Medium breakpoint (md)
                fontSize: "inherit", // Keep the original size
              },
              "& .MuiTableSortLabel-root": {
                color: "#000000 !important",
                "&.MuiTableSortLabel-active": {
                  color: "#000000 !important",
                },
              },
              "& .MuiTableSortLabel-icon": {
                color: "#000000 !important",
              },
              "&:hover": {
                color: "#ffffff !important",
                backgroundColor: "#929292 !important",
              },
            },
            body: {
              padding: "7px 15px",
              color: "#000000",
              borderBottom: "0px solid #ECECEC",
              borderRight: "0px solid #000000",
            },
            footer: {
              padding: "7px 15px",
              borderBottom: "0px solid #ECECEC",
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              backgroundColor: "#F1F1F1", // Change search input background color
              borderRadius: "1px", // Optional: Add border-radius for better UI
              padding: "1px 5px",
              color: "#6A6A6A !important",
              borderBottom: "0px",
            },
          },
        },
      },
    });

  return (
    <>
      {regularizeFormShow && (
        <div className="fixed inset-0 flex items-center justify-center bg-[#000000] bg-opacity-60 z-50 md:p-0 p-2">
          <div className="p-6 w-full md:w-1/2 mx-auto bg-white rounded-md shadow-md">
            <h2 className="text-xl font-semibold mb-4">
              New Regularization Request
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4 text-[#000000]">
              <div className="col-span-2 relative">
                <TextField
                  select
                  name="dcode"
                  label="Select District"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={formData.dcode}
                  onChange={handleChange}
                  required
                >
                  <MenuItem key={userDetails.dcode} value={userDetails.dcode}>
                    {userDetails.district}
                  </MenuItem>
                </TextField>
              </div>
              <div className="col-span-2 relative">
                <TextField
                  select
                  name="srocode"
                  label="Select SRO"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={formData.srocode}
                  onChange={handleChange}
                  required
                  disabled={!formData.dcode}
                >
                  {sros.map((sro) => (
                    <MenuItem key={sro.srocode} value={sro.srocode}>
                      {sro.sroname}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="md:col-span-1 col-span-2 relative">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="From Date"
                    value={fromDate}
                    onChange={(newValue) => setFromDate(newValue)}
                    slotProps={{ textField: { size: "small" } }}
                  />
                </LocalizationProvider>
              </div>
              <div className="md:col-span-1 col-span-2 relative">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="To Date"
                    value={selectedDate}
                    onChange={(newValue) => setSelectedDate(newValue)}
                    slotProps={{ textField: { size: "small" } }}
                  />
                </LocalizationProvider>
              </div>
              <div className="col-span-2 relative">
                <TextField
                  select
                  name="behalfOf"
                  label="On Behalf of"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={formData.behalfOf}
                  onChange={handleChange}
                  required
                >
                  {staffSro.map((staffs) => (
                    <MenuItem key={staffs.login_id} value={staffs.login_id}>
                      {staffs.username}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-span-2 relative">
                <TextField
                  select
                  name="userRole"
                  label="Assigned Role"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={formData.userRole}
                  onChange={handleChange}
                  required
                >
                  {roles.map((role) => (
                    <MenuItem key={role.roleId} value={role.roleName}>
                      {role.roleName}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-span-2 relative">
                <TextField
                  select
                  label="Name of Assignee"
                  name="assigneeName"
                  size="small"
                  value={formData.assigneeName}
                  fullWidth
                  variant="outlined"
                  onChange={handleChange}
                  required
                >
                  {staff.map((staf) => (
                    <MenuItem key={staf.login_id} value={staf.login_id}>
                      {staf.username}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-span-2 relative border-dashed bg-[#F3F9FF] rounded-md border-2 border-[#4F9CF9] p-1 flex justify-between items-center">
                <span className="text-gray-500">Upload Letter</span>
                <input
                  type="file"
                  id="upload"
                  hidden
                  onChange={handleFileUpload}
                />
                <label htmlFor="upload">
                  <Button
                    variant="contained"
                    component="span"
                    startIcon={<CloudUpload />}
                    size="small"
                    InputProps={{
                      sx: {
                        height: "34px", // Adjust the height as needed
                        padding: "0px", // Adjust the padding inside the box
                      },
                    }}
                  >
                    Upload
                  </Button>
                </label>
              </div>
              <div className="col-span-1 relative md:col-end-3">
                <button
                  variant="contained"
                  color="primary"
                  className="w-full bg-[#4F9CF9] text-white px-6 py-2 rounded hover:bg-[#3e85db] focus:outline-none"
                >
                  Send Request
                </button>
              </div>
              <div className="col-span-1 relative md:col-end-4">
                <button
                  variant="contained"
                  // color="primary"
                  className="w-full text-[#DA0000] px-6 py-2 border border-[#DA0000] rounded hover:bg-[#ca3d3d] hover:text-[#ffffff] focus:outline-none"
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="py-8 flex w-full">
        <Box width="100%">
          <ThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              title={"Power Regularization"}
              data={TableData}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Box>
      </div>
    </>
  );
};

export default RegularizeTable;
